module.exports = __webpack_public_path__ + "img/pos_s2_icon4.41cff1f6.png";